import { render, staticRenderFns } from "./InfoScreen.vue?vue&type=template&id=7626407e"
import script from "./InfoScreen.vue?vue&type=script&lang=js"
export * from "./InfoScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports